import { render, staticRenderFns } from "./rightItem03.vue?vue&type=template&id=00648760&scoped=true&"
import script from "./rightItem03.vue?vue&type=script&lang=js&"
export * from "./rightItem03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00648760",
  null
  
)

export default component.exports